import { defineStore } from 'pinia'
import { tryTellAppChatStats } from 'wap/hybrid'

export const useChatBall = defineStore('chatBall', {
  state: () => ({
    visible: false,
    newMessages: ''
  }),
  actions: {
    toggleVisible(bool = false) {
      this.visible = bool
    },
    updateNewMessages(num = 0) {
      this.newMessages = num > 99 ? '99+' : num
      sessionStorage.setItem('CHAT_NEW_MESSAGES_NUMS', num)
      tryTellAppChatStats(3, 0)
    }
  }
})
